<template>
  <div class="welcome-card-box">
    <div class="el-card is-never-shadow welcome-card">
      <div
        slot="header"
        class="el-card__header card-top"
      >
        <div
          class="card-title"
          @click="haddleTitle"
        >
          <span class="title">{{ title }}</span>
          <slot name="cardAction" />
        </div>
        <el-button
          v-if="showDelete"
          style="float: right; padding: 3px 0"
          type="text"
          @click="deleteCard"
        >
          <i class="el-icon-delete" />
        </el-button>
      </div>
      <div class="el-card__body card-content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      key: 1
    }
  },
  methods: {
    deleteCard () {
      this.$emit('deleteCard')
    },
    haddleTitle () {
      this.$emit('haddleTitle')
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-card {
  border: 1px solid #ebeef5 !important;
  .card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 12px !important;

    .card-title {
      display: flex;
      align-items: center;
      cursor: pointer;
      .title {
        margin-right: 12px;
        color: #666;
      }
    }
  }
  .card-content {
    padding: 0;
  }
}
</style>
